module.exports = __webpack_public_path__ + "media/images/undraw/matching/online_payments-a1727463e3cd73316a437ce4728eee5a.png";